import {useState} from 'react'
import Button from '@components/V3/Button'
import Notice from '@components/V3/Notice'

import {useCreateReservationContext} from '../../ReservationContext'

import {useCreateReservation} from './useCreateReservation.reservations'

export default function SubmitButton() {
  const isLocked = false
  const [errorMessage, setErrorMessage] = useState<string>()
  const context = useCreateReservationContext()
  const createReservation = useCreateReservation({setErrorMessage})

  return (
    <div>
      <Button
        className="mb-4"
        extraBig
        full
        type="button"
        primary
        disabled={isLocked}
        onClick={() => createReservation()}>
        {context.isWaitingList ? 'Ingresar a la lista de espera' : 'Reservar'}
      </Button>
      {errorMessage ? <Notice level="error">{errorMessage}</Notice> : null}
    </div>
  )
}
